import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingState from "../components/common/LoadingState";
import { canAccessPage } from "../utils/roleAccess";

export default function ProtectedRoute({ pageId = "" }) {
  const location = useLocation();
  const { initializing, isAuthenticated, user } = useAuth();

  if (initializing) {
    return (
      <LoadingState
        compact
        title="Loading session..."
        subtitle="Checking your access."
      />
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: `${location.pathname}${location.search}${location.hash}`,
        }}
      />
    );
  }

  if (pageId && !canAccessPage(user, pageId)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
